import React from 'react'
import AdminDashboard from '../../Components/admin/Dashboard'
function Dashboard() {
  return (
    <div>
     <AdminDashboard/>
    </div>
  )
}

export default Dashboard
